export default __webpack_public_path__ + "static/media/Sideways.049cfc0f.svg";